import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from '@ngneat/dialog';
import { environment } from 'environments/environment';
@Component({
    selector: 'page-500',
    template: `
        <div
            class="absolute inset-0 flex flex-col min-w-0 max-h-[100vh]"
            cdkScrollable
        >
            <!-- Main -->
            <div class="flex-auto" *ngIf="false">
                <div
                    class="w-full flex items-center justify-center h-full min-h-fit"
                >
                    <div class="text-center">
                        <img
                            src="assets/images/500.svg"
                            class="object-contain max-w-[230px] max-h-[230px]"
                            alt=""
                        />
                        <h1
                            class="text-center text-[90px] font-semibold text-[#0B0D13] leading-[110px] mt-4"
                        >
                            500
                        </h1>
                        <p
                            class="font-medium text-[22px] leading-[23px] text-[#7D7F86] text-center"
                        >
                            {{ errorMsg }}
                        </p>
                        <a
                            class="base_btn primary_btn mt-15"
                            [routerLink]="
                                isCustomer ? '/auth/signin' : '/dashboard'
                            "
                            >Back to {{ backTo }}</a
                        >
                    </div>
                </div>
            </div>

            <!-- Main -->
            <div class="flex-auto max-h-[100vh]">
                <div
                    class="w-full grid grid-cols-1 lgx:grid-cols-2 pb-[15vh] max-h-[100vh] overflow-hidden justify-center h-full"
                >
                    <div class="col-span-1 h-full overflow-hidden">
                        <img
                            [src]="'500_new.svg' | imagePath"
                            class="object-contain h-full"
                            alt=""
                        />
                    </div>
                    <div
                        class="col-span-1 flex flex-col justify-end items-center lgx:items-start max-lgx:mt-5 lgx:pl-10 lgx:pr-[25%]"
                    >
                        <div class="lgx:h-[98px] lgx:mb-7">
                            <img
                                [src]="'500_text.png' | imagePath"
                                class="lgx:h-[98px] h-[60px] w-max"
                                alt="500"
                            />
                        </div>
                        <p
                            class="text-[26px] leading-[1.5] lgx:text-[38px] lgx:leading-[47.5px] lgx:mb-[21px] text-[#050714]"
                        >
                            Oops... Internal Server Error!
                        </p>
                        <p
                            class="lgx:text-2xl text-xl leading-tight text-[#555760] mb-5 lgx:mb-[48px] max-w-[540px] max-lgx:text-center"
                        >
                            We’re working towards creating something better, We
                            won’t be long.
                        </p>
                        <a class="w-fit h-fit" [routerLink]="'/' + backTo">
                            <outline-btn-loading
                                btnClass="primary-outline-btn py-[14px] no_shadow outline-none text-base leading-normal font-medium mr-0 px-[21px]"
                                >Explore the platform</outline-btn-loading
                            ></a
                        >
                    </div>
                </div>
            </div>
        </div>
    `,
    styles: [],
    host: { class: 'w-full h-full' },
})
export class Error500Component {
    errorMsg: any = 'Internal Server Error';
    backTo: any = 'Dashboard';
    isCustomer: boolean = true;
    private dialog = inject(DialogService);

    constructor(private _matDialog: MatDialog) {
        this.dialog.closeAll();
        this._matDialog.closeAll();
        if (localStorage.getItem('currentUser')) {
            let user = JSON.parse(localStorage.getItem('currentUser'));
            if (user) {
                this.backTo = 'Dashboard';
                this.isCustomer = false;
            } else {
                this.backTo = 'Home';
                this.isCustomer = true;
            }
        } else {
            this.backTo = 'Home';
            this.isCustomer = true;
        }
    }
}
